import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { fetchAllPostsAction, fetchDetailsAction, postCommentAction } from '../store/actions/PostActions';
import Loader from '../components/Loader';
import moment from 'moment';
import { htmlToText } from 'html-to-text';
import Comments from '../components/Comments';
import { Toaster, toast } from 'react-hot-toast';
import { Helmet } from 'react-helmet';

const Details = () => {
    
    const [comment, setComment] = useState(null);
    const { slug } = useParams();
    const { loading, message } = useSelector(state => state.PostReducer);
    let { user } = useSelector(state => state.AuthReducer);
    user = user._id;
    const { details, comments } = useSelector(state => state.FetchDetailsReducer);
    const dispatch = useDispatch();
    useEffect(() => {
      dispatch(fetchDetailsAction(slug));
    }, [slug]);
    
    const addComment = (e) =>
    {
        e.preventDefault();
        if(user && details._id && comment)
        {
            console.log(details._id);
            const postId = details._id;
            dispatch(postCommentAction({ comment, user, postId }));
            setComment("");
            dispatch(fetchDetailsAction(slug));
        }
        else
        {
            toast.error("Something went wrong !!");
        }
    }
    
  return (
    !loading ?
    <section className="details-section">
        <Helmet>
            <title>Blog Details</title>
            <meta name="description" content="Blog Details" />
        </Helmet>
        <Toaster
          position='top-center'
          reverseOrder = "false"
          toastOptions={{
          style: {
              fontSize : "1.25rem",
              fontWeight : "700",
              marginTop : "110px"
          },
          }}
        />
        <div className="details">
        {
                !loading ? Object.keys(details).length > 0  ? 
                    <div className="box">
                        <div className="content">
                            <div className="author">
                                <img src={details.user.profilePicture} alt="" />
                                <div className="name-date">
                                    <div className="name">{details.user.firstName + " " + details.user.lastName}</div>
                                    <div className="date">{moment(details.updatedAt).format("MMM Do YYYY")}</div>
                                </div>
                            </div>
                            <div className="body">
                                <h1 className="title">{details.title}</h1>
                                <div className="desc">{htmlToText(details.body)}</div>
                            </div>
                        </div>
                        <div className="image">
                            <img src={details.image} alt="" />
                        </div>
                        {
                            user ?
                            <form action="" className="comment-form" onSubmit={addComment}>
                            <input type="text" 
                                className='comment' 
                                style={{ backgroundColor : "white" }} 
                                placeholder='Place your Comment...' 
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                            />
                            <input type="submit" value="Post Comment" className="primary-btn" />
                        </form> : null
                        }
                    </div>
                 : "Don't have details !" : <Loader />
            }
            {
                comments.length === 0 ?
                null :
                <Comments comments={comments} />
            }
        </div>
    </section> : <Loader />
  )
}

export default Details